import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";

const ModalShowRep = ({ show, handleClose, data, type, onDeleteChange }) => {
  const ITEMS_PER_PAGE = 7;
  const [tempSelectedData, setTempSelectedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(""); // State untuk search

  useEffect(() => {
    if (show) {
      setTempSelectedData(data); // Sinkronisasi data saat modal dibuka
      setSearchQuery(""); // Reset search saat modal dibuka
      setCurrentPage(1); // Reset ke halaman pertama
    }
  }, [show, data]);

  // Filter data berdasarkan searchQuery
  const filteredData = tempSelectedData.filter(
    (item) =>
      item.name_first.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (item.msisdn && item.msisdn.includes(searchQuery)) ||
      (item.email && item.email.toLowerCase().includes(searchQuery))
  );

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleDelete = (id) => {
    const updatedData = tempSelectedData.filter(
      (item) => item.idt_contact !== id
    );
    setTempSelectedData(updatedData);

    // Reset halaman jika semua data terhapus
    if (updatedData.length === 0) {
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    if (filteredData.length === 0) {
      setCurrentPage(1); // Reset ke halaman pertama jika tidak ada data setelah filtering
    }
  }, [filteredData]);

  const handleSubmit = () => {
    onDeleteChange(tempSelectedData); // Update ke parent
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Show Recipient</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Search Bar */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div></div> {/* Kosong untuk menjaga posisi */}
          <Form.Control
            type="text"
            placeholder="Search..."
            className="w-25"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        {/* Tabel Data */}
        <>
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-custome w-100">
              <thead>
                <tr className="text-white">
                  <th className="p-2">First Name</th>
                  <th className="p-2">Last Name</th>
                  <th className="p-2">Title</th>
                  <th className="p-2">Date of Birth</th>
                  <th className="p-2">MSISDN</th>
                  <th className="p-2">Email</th>
                  <th className="p-2">Address</th>
                  <th className="p-2">Group</th>
                  {type === "contacts" && (
                    <th className="p-2 text-center">Actions</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <tr key={index}>
                      <td className="p-2">{item.name_first}</td>
                      <td className="p-2">{item.name_last}</td>
                      <td className="p-2">{item.title}</td>
                      <td className="p-2">
                        {item.date_of_birth
                          ? moment(item.date_of_birth).format("DD-MM-YYYY")
                          : null}
                      </td>
                      <td className="p-2">{item.msisdn}</td>
                      <td className="p-2">{item.email}</td>
                      <td className="p-2">{item.address}</td>
                      <td className="p-2">{item.contact_group}</td>
                      {type === "contacts" && (
                        <td className="p-2 text-center">
                          <Button
                            variant="danger"
                            size="sm"
                            title="delete"
                            onClick={() => handleDelete(item.idt_contact)}
                          >
                            <FaTrash />
                          </Button>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr className="p-2">
                    <td colSpan="7" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-between">
              <div>
                Page {currentPage} of {totalPages}
              </div>
              <div>
                <Button
                  variant="primary"
                  className="btn btn-sm me-2"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  Prev
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-sm"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </Button>
              </div>
            </div>
          )}
        </>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          Close
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalShowRep;
